import { datajsAll } from '../shared/utils';
import Swiper, { Pagination, Navigation } from 'swiper';

export default class CaseGallerySlider {
	static init() {
		const sliders = datajsAll('case-gallery-slider');

		sliders.forEach((slider) => {
			this.sliderConfig(slider);
		});
	}

	static sliderConfig(slider) {
		// eslint-disable-next-line no-new
		new Swiper(slider, {
			modules: [Pagination, Navigation],
			loop: false,
			slidesPerView: 1,
			speed: 500,

			navigation: {
				nextEl: '[data-js~=carousel-next]',
				prevEl: '[data-js~=carousel-prev]',
				clickable: true,
			},

			// If we need pagination
			pagination: {
				el: '.m-sliderPagination',
				bulletClass: 'm-sliderPagination__item',
				bulletActiveClass: 'is-active',
				clickable: true,
			},
		});
	}
}
